import { common } from "./common.service"

export const mainDataService = {
    get,
}

function get(version) {
    const url = `Catalog`;
    return common.fetchAPI({ url, method: "GET" });
}